import React from 'react';
import { SizeProp } from '@fortawesome/fontawesome-svg-core';
import { faEyeSlash } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import cs from 'classnames';

import Tooltip from 'shared/components/atoms/Tooltip/NewTooltip';
import { Flex } from 'shared/components/display';

import COLORS from 'shared/styles/colors';

import styles from './styles';

interface Props {
  className?: string;
  size?: SizeProp;
  showTooltip?: boolean;
  showHoverBox?: boolean;
}
const InternalOnlyBadge: React.FC<Props> = ({ className, size = 'lg', showTooltip = false, showHoverBox = false }) => {
  return (
    <Tooltip content="Internal only" disabled={!showTooltip}>
      <Flex
        css={styles}
        className={cs('internal-only-badge', {
          'internal-only-badge--hover': showHoverBox,
        })}
      >
        <FontAwesomeIcon icon={faEyeSlash} size={size} className={className} color={COLORS.NEUTRAL600} />
      </Flex>
    </Tooltip>
  );
};

export default InternalOnlyBadge;
